<section *ngIf="license">
    <mat-card class="license-overview">
        <div class="ui-chip-container">
            <div *ngIf="license!.isRegistered"
                 class="ui-chip ui-chip-blue">
                <ng-container *ngIf="!license.hostLicenseId; else hostLicenseTmpl">
                    {{ 'license_info_license_key' | translate }}: {{ license.code }}
                </ng-container>
                <ng-template #hostLicenseTmpl>
                    {{ 'tenant_grid_host_license' | translate }}
                </ng-template>
            </div>
            <div *ngIf="license!.isRegistered && serverActivationId$ | async"
                 class="ui-chip ui-chip-blue">
                {{ 'license_dashboard_activation_id' | translate}}: {{ serverActivationId$ | async }}
            </div>
            <ui-license-status [license]="license">
            </ui-license-status>
        </div>
        <div uiDragAndDropFile
             [fileBrowseRef]="browseTrigger._getHostElement()"
             (fileChange)="onSubmit($event)"
             class="license-overview-actions">
            <ng-container *ngIf="isHost &&
                                license!.isRegistered &&
                                !license!.isExpired">
                <button [matTooltip]="'settings_license_allocate_tooltip' | translate"
                        (click)="allocate.emit()"
                        mat-button
                        color="primary"
                        class="license-action-button"
                        type="button"
                        data-cy="allocate-license">
                    {{ 'license_tenant_allocate_placeholder' | translate }}
                </button>
                <span class="button-divider"></span>
            </ng-container>
            <button #browseTrigger
                    [hidden]="!isLegacyMode"
                    [disableIf]="isLoading"
                    [spinnerButtonLoading]="isLoading"
                    [uiAuthorizeAll]="editPermission"
                    [matTooltip]="'settings_license_form_upload' | translate"
                    ui-spinner-button
                    mat-button
                    type="button"
                    color="primary"
                    class="license-action-button">
                <ng-container *ngIf="license!.isRegistered; else upload">
                    {{ 'license_action_renew' | translate }}
                </ng-container>
                <ng-template #upload>
                    {{ 'license_action_upload' | translate }}
                </ng-template>
            </button>
            <ng-container *ngIf="!license!.isRegistered">
                <button [disableIf]="isLoading"
                        [spinnerButtonLoading]="isLoading"
                        [uiAuthorizeAll]="editPermission"
                        [matTooltip]="'modal_action_activate_online' | translate"
                        (click)="openActivateOnlineModal()"
                        ui-spinner-button
                        mat-button
                        type="button"
                        color="primary"
                        class="license-online-action-button"
                        data-cy="license-online-action-button">
                    {{ 'modal_action_activate_online' | translate }}
                </button>
                <button [disableIf]="isLoading"
                        [spinnerButtonLoading]="isLoading"
                        [uiAuthorizeAll]="editPermission"
                        [matTooltip]="'modal_action_activate_offline' | translate"
                        (click)="openActivateOfflineModal()"
                        ui-spinner-button
                        mat-button
                        type="button"
                        color="primary"
                        class="license-offline-action-button"
                        data-cy="license-offline-action-button">
                    {{ 'modal_action_activate_offline' | translate }}
                </button>
            </ng-container>
            <ng-container *ngIf="license!.isRegistered">
                <button *ngIf="isHost || !license.hostLicenseId"
                        [disableIf]="isLoading"
                        [spinnerButtonLoading]="isLoading"
                        [uiAuthorizeAll]="editPermission"
                        [matTooltip]="'modal_action_update' | translate"
                        (click)="openUpdateModal()"
                        ui-spinner-button
                        mat-button
                        type="button"
                        color="primary"
                        class="license-update-action-button"
                        data-cy="license-update-action-button">
                    {{ 'modal_action_update' | translate }}
                </button>
                <button [disableIf]="isLoading"
                        [spinnerButtonLoading]="isLoading"
                        [uiAuthorizeAll]="deletePermission"
                        [matTooltip]="'settings_license_form_remove' | translate"
                        (click)="removeLicense($event)"
                        ui-spinner-button
                        mat-button
                        type="button"
                        color="warn"
                        class="license-action-button">
                    {{ 'license_action_remove' | translate }}
                </button>
            </ng-container>
        </div>
    </mat-card>

    <div *ngIf="license!.isRegistered || license!.isCommunity"
         class="layout-row layout-wrap mat-typography">

        <div *ngFor="let licenseInfo of licenseDefinitions"
             class="card-container flex-gt-md-20 flex-md-50 flex-sm-50 flex-xs-100">
            <ui-license-usage [license]="license"
                              [licenseInfo]="licenseInfo"
                              [isHost]="isHost">
            </ui-license-usage>
        </div>
    </div>

    <div class="layout-row layout-wrap">
        <div class="card-container flex-100">
            <ui-license-chart [isHost]="isHost"></ui-license-chart>
        </div>
    </div>
</section>
